import ProductPageDetails from "components/product/page";
import RenderModules from "helpers/render-modules";
import BaseLayout from "layouts/base-layout";
import React from "react";
import ImageSlideShow from "components/image-slide-show";
import { useEffect } from "react";
import { trackViewItem } from "services/analytics";
import ProductRichSnippets from "components/rich-snippets/product";

export { Head } from "components/head";

const ProductPage = ({ pageContext, path }) => {
	const { pdpSettings = {}, product = {}, header, footer, breadcrumbs, pageSettings } = pageContext;

	useEffect(() => {
		trackViewItem({
			title: product?.title,
			type: product?.type,
			variant: product?.variant,
		});
	}, []);

	const modules = [...(pageContext.modules || []), ...(pdpSettings.modules || [])];

	return (
		<BaseLayout
			path={path}
			header={header}
			footer={footer}
			breadcrumbs={breadcrumbs}
			title={product?.title}
			pageSettings={pageSettings}
		>
			<div className="w-90 m-auto flex flex-col lg:flex-row justify-between my-10 gap-x-10 hd-screen-max-width">
				<div className="w-full my-2">
					<ImageSlideShow images={product?.images} />
				</div>
				<div className="w-full my-2 md:sticky md:top-20 md:h-full">
					{console.log("Rendering ProductPageDetails with product:", product)}
					<ProductPageDetails product={product} />
				</div>
			</div>

			<div className="m-auto my-10">
				<RenderModules modules={modules} sku={product.variant.sku} />
			</div>
			<ProductRichSnippets product={product} />
		</BaseLayout>
	);
};

export default ProductPage;